import { render, staticRenderFns } from "./AnimationGenerator.vue?vue&type=template&id=130151b8&scoped=true&"
import script from "./AnimationGenerator.vue?vue&type=script&lang=js&"
export * from "./AnimationGenerator.vue?vue&type=script&lang=js&"
import style0 from "./AnimationGenerator.vue?vue&type=style&index=0&id=130151b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130151b8",
  null
  
)

export default component.exports